module.exports = __webpack_public_path__ + "img/floor_UG2.813e34af.svg";